import Result from "./result";

class Response {
  public Results: Result[];

  public Count: number;
  public Total: number;

  public FacetValues: any;

  constructor(
    results: Result[],
    count: number,
    total: number,
    facetValues: any
  ) {
    this.Results = results;
    this.Count = count;
    this.Total = total;
    this.FacetValues = facetValues;
  }
}

export default Response;



// WEBPACK FOOTER //
// ./src/models/response.ts